export type DayLabel = "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday";

export class WorkingHours {

    private _id: number;
    private _day: number;
    private _day_label: DayLabel | null;
    private _open: string;
    private _close: string;
    private _restaurant_id: number;

    constructor() {
        this._id = 0;
        this._day = 0;
        this._day_label = null;
        this._open = "";
        this._close = "";
        this._restaurant_id = 0;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get day(): number {
        return this._day;
    }

    set day(value: number) {
        this._day = value;
    }

    get day_label(): DayLabel | null {
        return this._day_label;
    }

    set day_label(value: DayLabel | null) {
        this._day_label = value;
    }

    get open(): string {
        return this._open;
    }

    set open(value: string) {
        this._open = value;
    }

    get close(): string {
        return this._close;
    }

    set close(value: string) {
        this._close = value;
    }

    get restaurant_id(): number {
        return this._restaurant_id;
    }

    set restaurant_id(value: number) {
        this._restaurant_id = value;
    }
}